import { AthenaEvent } from "@evidenceb/athena-event-storage-schemas";
import { AthenaEventSaveResult } from "./AthenaEventSaveResult.js";
import { EventStorageClient } from "./EventStorageClient.js";

/**
 * Mock, no-op version of the EventStorageClient. To be used in the Athena's
 * specimen.
 */
export class MockEventStorageClient implements EventStorageClient {
  public eventStorageOrigin = "MockEventStorageOrigin";

  async saveAthenaEvents(
    athenaEvents: AthenaEvent<any, any>[],
    _options?: any,
  ): Promise<AthenaEventSaveResult[]> {
    return athenaEvents.map((athenaEvent) => ({
      athenaEvent: athenaEvent,
      succeeded: true,
      error: null,
    }));
  }

  async fetchAthenaEvents(_filters: any): Promise<AthenaEvent<any, any>[]> {
    return [];
  }
}
